
import randomColor from "randomcolor";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ContactCard extends Vue {
  @Prop(Array) readonly items!: any[];

  initialColor() {
    return randomColor({
      luminosity: "dark",
    });
  }

  message(id: string): void {
    this.$router.push({
      name: "inbox",
      query: {
        recipientUserId: id,
      },
    });
  }
}
